import { Client } from "@/Common/Api/Client";
import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { MedicationResponse } from "@/Patient/Models/Medication/ResponseModels/MedicationResponse";

export function resolveMedication(
    medicationResponseLight: MedicationResponse,
    MedicationId: string,
    then: (responseFull: MedicationResponse) => void
): void {
    const requestData = {
        CodeGen: medicationResponseLight.CodeGen,
        Form: medicationResponseLight.Form,
        Strength: medicationResponseLight.Strength,
        Name: medicationResponseLight.Name,
        MedicationId: MedicationId
    };

    const client = new Client();
    const path = apiSettings.buildApiPath();

    client.Post(
        path,
        ServerOperations.Server.MedfarDictionary_ResolveMedicationFromSearch,
        requestData,
        response => {
            then(response.FullMedicationDTO);
        },
        error => console.error(error),
        GuidHelper.NewGuid()
    );
}
